import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { Testimonial } from './components/Testimonial';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <Hero data-id="element-2" />
      <HookSection data-id="element-3" />
      <PainSection data-id="element-4" />
      <RevelationSection data-id="element-5" />
      <Testimonial data-id="element-6" />
      <OfferSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}